import { Box, useMediaQuery } from "@mui/material";
import React from "react";
import { useTheme } from "@emotion/react";
import PreTestShapesImg from "assets/images/PreTestShapes.svg";
import GradientFramedLayout from "components/v3/layouts/GradientFramedLayout";

interface SideMenuLayoutProps {
  children: React.ReactNode;
  loaded?: boolean;
  onboardingStepper: React.ReactNode;
}

const SideMenuLayout: React.FC<SideMenuLayoutProps> = ({
  children,
  loaded = false,
  onboardingStepper
}) => {
  const theme = useTheme();
  //@ts-ignore - Don't want to fix the breakpoints on the theme right now.
  const screenWidthIsLgOrSmaller = useMediaQuery(theme.breakpoints.down("lg"));

  const sideOrTopStepper = screenWidthIsLgOrSmaller ? (
    <Box flex="0" sx={{ display: "contents" }}>
      {onboardingStepper}
    </Box>
  ) : (
    <Box flex="0 0 370px">{onboardingStepper}</Box>
  );
  return (
    <Box
      sx={{
        background:
          "linear-gradient(180deg, #F2F7FB 0%, rgba(242, 247, 251, 0.00) 62.6%)",
        minHeight: "100dvh"
      }}
    >
      <GradientFramedLayout showHeader={true}>
        <Box
          sx={{
            boxSizing: "border-box",
            display: "flex",
            flexDirection: {
              xs: "column",
              lg: "row"
            },
            minHeight: "100vh",
            padding: {
              xs: "0px 0px 60px 0px",
              lg: "100px 50px 110px 50px"
            },
            width: "100%"
          }}
        >
          {sideOrTopStepper}
          <Box
            sx={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
              width: "100%"
            }}
          >
            {children}
          </Box>
          {!screenWidthIsLgOrSmaller && loaded && (
            <Box
              sx={{
                bottom: "-5px",
                left: "145px",
                position: "absolute"
                // zIndex: -1
              }}
            >
              <Box
                component="img"
                sx={{
                  height: {
                    xs: "100px",
                    lg: "auto"
                  },
                  objectFit: "contain",
                  width: {
                    xs: "104px",
                    lg: "auto"
                  }
                }}
                src={PreTestShapesImg}
                alt=""
              />
            </Box>
          )}
        </Box>
      </GradientFramedLayout>
    </Box>
  );
};

export default SideMenuLayout;
